/**
 * Whether a redirect/navigation target is safe to hand to window.location.href
 * or window.open(). Resolves relative URLs against the current origin and
 * only allows the http/https schemes through — blocks `javascript:`, `data:`,
 * `vbscript:` and similar schemes that would execute if a value that ends up
 * here (e.g. a `redirect_url` from an API response) is ever attacker-controlled.
 *
 * CVE fix (Aikido): "Potential XSS via window.location.href" — 8 subissues,
 * all raw `window.location.href = <value from API response>` assignments.
 * @param url
 * @return {boolean}
 */
export const isSafeRedirectUrl = url => {
	if (typeof url !== 'string' || url.trim() === '') {
		return false;
	}

	try {
		const resolved = new URL(url, window.location.origin);
		return resolved.protocol === 'http:' || resolved.protocol === 'https:';
	} catch (e) {
		return false;
	}
};

/**
 * Open new window
 * @param url
 * @param target
 */
export const openWindow = (url, target) => {
	if (!isSafeRedirectUrl(url)) {
		console.error('Blocked unsafe window target:', url);
		return;
	}

	if (typeof window.open !== 'undefined') {
		window.open(url, target);
	} else {
		// window.location.href = url;
		safeRedirect(url);
	}

	// safari redirect
	if (isIosSafari()) {
		// window.location.href = url;
		// window.location.assign(url);
		safeRedirect(url);
	}
};


/**
 * Safe redirect
 * @param url
 */
export const safeRedirect = url => {
	if (!isSafeRedirectUrl(url)) {
		console.error('Blocked unsafe redirect target:', url);
		return false;
	}

	// location = url;
	window.location.href = url;
	return false;
};

/**
 * Check if is iOS safari.
 * @return {boolean}
 */
export const isIosSafari = () => {
	let ua = window.navigator.userAgent;
	let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	let webkit = !!ua.match(/WebKit/i);
	return iOS && webkit && !ua.match(/CriOS/i);
};


export const isMobile = () => {
	return $(window).width() < 750;
};
